export const locations = {
    Graz: "Graz",
    Innsbruck: "Innsbruck",
    Linz: "Linz",
    Wien: "Wien"
};

export const grades = {
    ausgezeichnet: {
        title: "ausgezeichnet",
        index: 0
    },
    sehrgut: {
        title: "sehr gut",
        index: 1
    },
    bestanden: {
        title: "bestanden",
        index: 2
    },
    nichtbestanden: {
        title: "nicht bestanden",
        index: 3
    }
}

const raData = [
    //Graz
    {
        location: locations.Graz,
        year: 1993,
        data: [2, 6, 0, 0]
    },
    {
        location: locations.Graz,
        year: 1994,
        data: [11, 12, 1, 0]
    },
    {
        location: locations.Graz,
        year: 1995,
        data: [7, 13, 7, 0]
    },
    {
        location: locations.Graz,
        year: 1996,
        data: [10, 26, 7, 2]
    },
    {
        location: locations.Graz,
        year: 1997,
        data: [7, 16, 14, 2]
    },
    {
        location: locations.Graz,
        year: 1998,
        data: [8, 18, 16, 1]
    },
    {
        location: locations.Graz,
        year: 1999,
        data: [5, 20, 14, 2]
    },
    {
        location: locations.Graz,
        year: 2000,
        data: [17, 11, 12, 2]
    },
    {
        location: locations.Graz,
        year: 2001,
        data: [13, 19, 9, 4]
    },
    {
        location: locations.Graz,
        year: 2002,
        data: [16, 19, 20, 0]
    },
    {
        location: locations.Graz,
        year: 2003,
        data: [5, 28, 21, 4]
    },
    {
        location: locations.Graz,
        year: 2004,
        data: [8, 12, 26, 1]
    },
    {
        location: locations.Graz,
        year: 2005,
        data: [5, 19, 15, 5]
    },
    {
        location: locations.Graz,
        year: 2006,
        data: [2, 29, 15, 1]
    },
    {
        location: locations.Graz,
        year: 2007,
        data: [3, 16, 26, 4]
    },
    {
        location: locations.Graz,
        year: 2008,
        data: [1, 16, 22, 6]
    },
    {
        location: locations.Graz,
        year: 2009,
        data: [6, 20, 28, 2]
    },
    {
        location: locations.Graz,
        year: 2010,
        data: [1, 9, 25, 3],
        RA: 777,
        RAA: 236
    },
    {
        location: locations.Graz,
        year: 2011,
        data: [6, 13, 18, 4]
    },
    {
        location: locations.Graz,
        year: 2012,
        data: [2, 22, 24, 2]
    },
    {
        location: locations.Graz,
        year: 2013,
        data: [6, 10, 15, 3]
    },
    {
        location: locations.Graz,
        year: 2014,
        data: [5, 22, 14, 2]
    },
    {
        location: locations.Graz,
        year: 2015,
        data: [7, 14, 26, 3]
    },
    {
        location: locations.Graz,
        year: 2016,
        data: [7, 17, 22, 10]
    },
    {
        location: locations.Graz,
        year: 2017,
        data: [5, 14, 16, 8]
    },
    {
        location: locations.Graz,
        year: 2018,
        data: [5, 13, 18, 2],
        RA: 830,
        RAA: 249
    },
    {
        location: locations.Graz,
        year: 2019,
        data: [6, 11, 17, 5],
        RA: 828,
        RAA: 279
    },
    {
        location: locations.Graz,
        year: 2020,
        data: [5, 16, 21, 4],
        RA: 830,
        RAA: 273
    },

    //Innsbruck
    {
        location: locations.Innsbruck,
        year: 1993,
        data: [0, 3, 6, 0]
    },
    {
        location: locations.Innsbruck,
        year: 1994,
        data: [3, 7, 11, 1]
    },
    {
        location: locations.Innsbruck,
        year: 1995,
        data: [1, 7, 19, 5]
    },
    {
        location: locations.Innsbruck,
        year: 1996,
        data: [2, 12, 26, 3]
    },
    {
        location: locations.Innsbruck,
        year: 1997,
        data: [7, 13, 23, 4]
    },
    {
        location: locations.Innsbruck,
        year: 1998,
        data: [3, 11, 20, 6]
    },
    {
        location: locations.Innsbruck,
        year: 1999,
        data: [2, 16, 17, 5]
    },
    {
        location: locations.Innsbruck,
        year: 2000,
        data: [6, 9, 22, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2001,
        data: [3, 14, 22, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2002,
        data: [2, 12, 23, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2003,
        data: [3, 13, 20, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2004,
        data: [6, 11, 22, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2005,
        data: [4, 14, 24, 3]
    },
    {
        location: locations.Innsbruck,
        year: 2006,
        data: [0, 15, 19, 0]
    },
    {
        location: locations.Innsbruck,
        year: 2007,
        data: [0, 13, 19, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2008,
        data: [2, 10, 22, 4]
    },
    {
        location: locations.Innsbruck,
        year: 2009,
        data: [0, 9, 24, 6]
    },
    {
        location: locations.Innsbruck,
        year: 2010,
        data: [2, 8, 31, 3],
        RA: 753,
        RAA: 151
    },
    {
        location: locations.Innsbruck,
        year: 2011,
        data: [1, 9, 21, 5]
    },
    {
        location: locations.Innsbruck,
        year: 2012,
        data: [1, 9, 18, 3]
    },
    {
        location: locations.Innsbruck,
        year: 2013,
        data: [4, 17, 16, 4]
    },
    {
        location: locations.Innsbruck,
        year: 2014,
        data: [4, 7, 17, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2015,
        data: [2, 12, 16, 3]
    },
    {
        location: locations.Innsbruck,
        year: 2016,
        data: [2, 12, 10, 2]
    },
    {
        location: locations.Innsbruck,
        year: 2017,
        data: [2, 21, 16, 5]
    },
    {
        location: locations.Innsbruck,
        year: 2018,
        data: [5, 11, 19, 0],
        RA: 783,
        RAA: 163
    },
    {
        location: locations.Innsbruck,
        year: 2019,
        data: [2, 11, 11, 1],
        RA: 787,
        RAA: 153
    },
    {
        location: locations.Innsbruck,
        year: 2020,
        data: [5, 17, 15, 0],
        RA: 787,
        RAA: 170
    },
    


    //Linz
    {
        location: locations.Linz,
        year: 1993,
        data: [0, 5, 3, 2]
    },
    {
        location: locations.Linz,
        year: 1994,
        data: [1, 12, 21, 0]
    },
    {
        location: locations.Linz,
        year: 1995,
        data: [1, 13, 28, 2]
    },
    {
        location: locations.Linz,
        year: 1996,
        data: [0, 13, 37, 4]
    },
    {
        location: locations.Linz,
        year: 1997,
        data: [3, 9, 30, 0]
    },
    {
        location: locations.Linz,
        year: 1998,
        data: [0, 14, 43, 6]
    },
    {
        location: locations.Linz,
        year: 1999,
        data: [0, 15, 36, 10]
    },
    {
        location: locations.Linz,
        year: 2000,
        data: [2, 17, 34, 4]
    },
    {
        location: locations.Linz,
        year: 2001,
        data: [1, 18, 34, 6]
    },
    {
        location: locations.Linz,
        year: 2002,
        data: [5, 16, 21, 6]
    },
    {
        location: locations.Linz,
        year: 2003,
        data: [3, 16, 25, 5]
    },
    {
        location: locations.Linz,
        year: 2004,
        data: [3, 20, 34, 6]
    },
    {
        location: locations.Linz,
        year: 2005,
        data: [1, 20, 33, 6]
    },
    {
        location: locations.Linz,
        year: 2006,
        data: [0, 24, 40, 8]
    },
    {
        location: locations.Linz,
        year: 2007,
        data: [2, 14, 28, 6]
    },
    {
        location: locations.Linz,
        year: 2008,
        data: [1, 13, 34, 5]
    },
    {
        location: locations.Linz,
        year: 2009,
        data: [1, 14, 22, 13]
    },
    {
        location: locations.Linz,
        year: 2010,
        data: [2, 15, 32, 5],
        RA: 1021,
        RAA: 308
    },
    {
        location: locations.Linz,
        year: 2011,
        data: [2, 20, 30, 7]
    },
    {
        location: locations.Linz,
        year: 2012,
        data: [3, 19, 34, 3]
    },
    {
        location: locations.Linz,
        year: 2013,
        data: [8, 9, 19, 6]
    },
    {
        location: locations.Linz,
        year: 2014,
        data: [5, 17, 24, 9]
    },
    {
        location: locations.Linz,
        year: 2015,
        data: [3, 14, 42, 6]
    },
    {
        location: locations.Linz,
        year: 2016,
        data: [0, 23, 34, 8]
    },
    {
        location: locations.Linz,
        year: 2017,
        data: [5, 19, 14, 7]
    },
    {
        location: locations.Linz,
        year: 2018,
        data: [7, 15, 32, 5],
        RA: 1102,
        RAA: 328
    },
    {
        location: locations.Linz,
        year: 2019,
        data: [8, 18, 30, 6],
        RA: 1110,
        RAA: 313
    },
    {
        location: locations.Linz,
        year: 2020,
        data: [1, 19, 38, 9],
        RA: 1113,
        RAA: 299
    },

    //Wien
    {
        location: locations.Wien,
        year: 1993,
        data: [2, 5, 3, 1]
    },
    {
        location: locations.Wien,
        year: 1994,
        data: [4, 23, 27, 5]
    },
    {
        location: locations.Wien,
        year: 1995,
        data: [18, 54, 38, 16]
    },
    {
        location: locations.Wien,
        year: 1996,
        data: [14, 53, 37, 12]
    },
    {
        location: locations.Wien,
        year: 1997,
        data: [28, 52, 55, 13]
    },
    {
        location: locations.Wien,
        year: 1998,
        data: [14, 68, 52, 14]
    },
    {
        location: locations.Wien,
        year: 1999,
        data: [15, 58, 64, 23]
    },
    {
        location: locations.Wien,
        year: 2000,
        data: [14, 51, 69, 24]
    },
    {
        location: locations.Wien,
        year: 2001,
        data: [24, 74, 68, 29]
    },
    {
        location: locations.Wien,
        year: 2002,
        data: [30, 65, 86, 34]
    },
    {
        location: locations.Wien,
        year: 2003,
        data: [17, 68, 86, 26]
    },
    {
        location: locations.Wien,
        year: 2004,
        data: [23, 96, 110, 31]
    },
    {
        location: locations.Wien,
        year: 2005,
        data: [19, 94, 96, 33]
    },
    {
        location: locations.Wien,
        year: 2006,
        data: [15, 72, 106, 37]
    },
    {
        location: locations.Wien,
        year: 2007,
        data: [22, 95, 101, 41]
    },
    {
        location: locations.Wien,
        year: 2008,
        data: [30, 69, 110, 34]
    },
    {
        location: locations.Wien,
        year: 2009,
        data: [17, 73, 121, 34]
    },
    {
        location: locations.Wien,
        year: 2010,
        data: [35, 62, 111, 50],
        RA: 2967,
        RAA: 1207
    },
    {
        location: locations.Wien,
        year: 2011,
        data: [21, 79, 108, 43]
    },
    {
        location: locations.Wien,
        year: 2012,
        data: [29, 79, 125, 34]
    },
    {
        location: locations.Wien,
        year: 2013,
        data: [25, 86, 129, 25]
    },
    {
        location: locations.Wien,
        year: 2014,
        data: [39, 72, 106, 41]
    },
    {
        location: locations.Wien,
        year: 2015,
        data: [45, 79, 132, 46]
    },
    {
        location: locations.Wien,
        year: 2016,
        data: [30, 108, 124, 35]
    },
    {
        location: locations.Wien,
        year: 2017,
        data: [36, 89, 125, 33]
    },
    {
        location: locations.Wien,
        year: 2018,
        data: [47, 97, 137, 47],
        RA: 3674,
        RAA: 1564
    },
    {
        location: locations.Wien,
        year: 2019,
        data: [42, 107, 134, 41],
        RA: 3844,
        RAA: 1592
    },
    {
        location: locations.Wien,
        year: 2020,
        data: [32, 78, 121, 46],
        RA: 3875,
        RAA: 1528
    },


];


export default raData;
